// extracted by mini-css-extract-plugin
export default {"games_section_headline":"notification_games_section_headline__DDAru","games_section_title":"notification_games_section_title__3bqjR"};